import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { CardModule } from 'primeng/card';
import { DividerModule } from 'primeng/divider';

import { PrivacyPolicyDTO } from '../../../../base/models/models.swagger.generated';
import { PrivacyPolicyService } from '../privacy-policy.service';

@Component({
  selector: 'app-public-privacy-policy',
  standalone: true,
  imports: [CommonModule, TranslateModule, CardModule, DividerModule],
  templateUrl: './public-privacy-policy.component.html',
  styleUrls: ['./public-privacy-policy.component.scss'],
  providers: [PrivacyPolicyService]
})
export class PublicPrivacyPolicyComponent implements OnInit, OnDestroy {
  public privacyPolicy: PrivacyPolicyDTO | null = null;
  private subscription = new Subscription();

  constructor(private privacyPolicyService: PrivacyPolicyService) {}

  ngOnInit(): void {
    this.loadLatestPrivacyPolicy();
  }

  private loadLatestPrivacyPolicy(): void {
    this.subscription.add(
      this.privacyPolicyService.getLatest().subscribe({
        next: (policy) => {
          this.privacyPolicy = policy;
        },
        error: (error) => {
          console.error('Error loading privacy policy:', error);
        }
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  get currentYear(): number {
    return new Date().getFullYear();
  }
}